import { render, staticRenderFns } from "./_ShareModal.vue?vue&type=template&id=0982e206&scoped=true&"
import script from "./_ShareModal.vue?vue&type=script&lang=ts&"
export * from "./_ShareModal.vue?vue&type=script&lang=ts&"
import style0 from "./_ShareModal.vue?vue&type=style&index=0&id=0982e206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982e206",
  null
  
)

component.options.__file = "_ShareModal.vue"
export default component.exports